module.exports = __webpack_public_path__ + "img/m2.5b22e46b.png";